import Button from "@components/ui/button";
import { useAppDispatch, useAppSelector } from "@store";
import { getAccount } from "@store/account/selectors";
import { closeDialog, openDialog } from "@store/dialogs";
import { useEffect } from "react";
import { track } from "@/features/analytics";
import { useAuthStoreShallow } from "@/features/authentication";
import { useUrlChange } from "@/shared";
import UpdateBillingDetailsDialog from "./update-billing-details-dialog";

const AccountIsOnHoldDialog = () => {
  const account = useAppSelector(getAccount);
  const isAdminOrAdministrator = useAuthStoreShallow(
    (s) => s.isAdminOrAdministrator,
  );
  const dispatch = useAppDispatch();

  useUrlChange((url) => {
    const excludeRegex =
      /^\/pages\/(profile\/(plans|users|subscription|invoices)|help)/;
    if (excludeRegex.test(url)) {
      dispatch(closeDialog("account-is-on-hold"));
    }
  });

  useEffect(() => {
    track("view account is on hold dialog");
  }, []);

  const onUpdateBillingDetails = () => {
    track("click update billing");
    dispatch(closeDialog("account-is-on-hold"));
    dispatch(
      openDialog({
        id: "update-billing-details",
        content: UpdateBillingDetailsDialog,
        props: {
          onClose: () => {
            dispatch(
              openDialog({
                id: "account-is-on-hold",
                content: AccountIsOnHoldDialog,
              }),
            );
          },
        },
      }),
    );
  };

  const onContactUs = () => {
    track("click contact us");
    window.open("https://help.storydoc.com", "_blank");
    dispatch(closeDialog("account-is-on-hold"));
  };

  return (
    <div className="tw-grid tw-w-[616px] tw-place-items-center tw-rounded-lg tw-bg-white tw-py-14 tw-shadow-main">
      <img
        src="/assets/images/account-is-on-hold.svg"
        width="184"
        height="184"
        alt=""
        className="tw-mb-10 tw-size-[184px]"
      />
      <h2 className="tw-mb-2 tw-mt-0 tw-text-center tw-font-sans tw-text-2xl tw-font-bold">
        Your account is on hold
      </h2>
      <p className="tw-mx-auto tw-mb-10 tw-mt-0 tw-max-w-[434px] tw-text-center tw-font-sans tw-text-base tw-font-normal">
        There has been an issue with your your plan's payment. Update your
        billing details to keep creating amazing presentations{" "}
      </p>
      <div className="tw-flex tw-items-center tw-justify-center">
        {isAdminOrAdministrator &&
          typeof account?.paymentsUpdateUrl === "string" && (
            <Button className="tw-mr-4" onClick={onUpdateBillingDetails}>
              <Button.Icon icon="ri-bank-card-fill" />
              Update billing
            </Button>
          )}
        <Button variant="secondary" onClick={onContactUs}>
          <Button.Icon icon="ri-mail-fill" />
          Contact us
        </Button>
      </div>
    </div>
  );
};

export default AccountIsOnHoldDialog;
